import { EnergyUsageDevice } from 'common';
import React from 'react';
import { PieChart } from 'react-gifted-charts';
import { Text, View, XStack, YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

interface TopLiveElectricalUsageContentProps {
    data: EnergyUsageDevice[];
}

export const TopLiveElectricalUsageContent: React.FC<TopLiveElectricalUsageContentProps> = ({ data: devices }) => {
    const colorPalette = [
        tokens.color.topUsageColor1,
        tokens.color.topUsageColor2,
        tokens.color.topUsageColor3,
        tokens.color.topUsageColor4,
        tokens.color.topUsageColor5,
    ];

    const maxValue = Math.max(...devices.map((device) => device.value));
    const data = devices.map((device, index) => ({
        name: device.name,
        value: Math.round(device.value) > 0 ? Math.round(device.value) : 0.1, // mock some data to make sure it will be displayed by the PieChart
        color: colorPalette[index],
        focused: maxValue > 0 && device.value === maxValue,
        power: Math.round(device.power),
    }));

    const chartRadius = 110;

    return (
        <XStack gap="$3" height="80%" alignItems="center" justifyContent="space-between">
            {maxValue >= 0 && (
                <PieChart
                    donut
                    innerRadius={chartRadius * 0.6}
                    showTextBackground
                    data={data}
                    radius={chartRadius}
                    sectionAutoFocus
                    innerCircleColor={tokens.color.darkBackground}
                    centerLabelComponent={() => (
                        <Text fontSize={42} fontWeight="700" color="$color12">
                            {maxValue > 0 ? Math.round(maxValue) : '<1'}%
                        </Text>
                    )}
                />
            )}
            {maxValue >= 0 && (
                <YStack gap="$4" alignSelf="center" minWidth={200}>
                    {data.map((item, index) => (
                        <XStack key={index} alignItems="center" gap="$3">
                            <View width={12} height={12} borderRadius={6} backgroundColor={item.color} />
                            <Text
                                flex={1}
                                color="$color12"
                                fontSize="$7"
                                fontWeight="500">
                                {item.name}
                            </Text>
                            <Text
                                backgroundColor={tokens.color.pillBackground}
                                borderRadius="$2"
                                fontSize="$5"
                                fontWeight="600"
                                color="$color12"
                                minWidth={55}
                                textAlign="center">
                                {item.value > 1 ? item.value : '<1'}%
                            </Text>
                        </XStack>
                    ))}
                </YStack>
            )}
        </XStack>
    );
};
